import { render } from "./MmRegionClaims.vue?vue&type=template&id=2dadeb62&scoped=true"
import script from "./MmRegionClaims.vue?vue&type=script&lang=js"
export * from "./MmRegionClaims.vue?vue&type=script&lang=js"

import "./MmRegionClaims.vue?vue&type=style&index=0&id=2dadeb62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dadeb62"]])

export default __exports__